import apiResource from '@/services/http/api/resource'

const defaultState = () => {
  return {
    bubbles: null,
    loader: null
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getBubbles: (state) => state.bubbles,
    getLoader: (state) => state.loader
  },
  mutations: {
    setBubbles(state, payload) {
      state.bubbles = payload
    },
    setLoader(state, payload) {
      state.loader = payload
    },
    clear(state) {
      state.bubbles = defaultState().bubbles
      state.loader = defaultState().loader
    }
  },
  actions: {
    getBubbles(context, payload) {
      context.commit('setLoader', true)
      apiResource
        .getBubbles(payload)
        .then(({ data }) => {
          context.commit('setBubbles', data.data)
          return data.data
        })
        .catch(() => {})
        .finally(() => {
          context.commit('setLoader', false)
        })
    }
  }
}
